import React, { useState } from "react";
import classes from "./ImportOptionsModal.module.css";

export default function ImportOptionsModal({
  onClose,
  onPreview,
  onImport,
  loading = false,
}) {
  const [updateMode, setUpdateMode] = useState(false);

  const handlePreview = () => {
    onPreview(updateMode);
    onClose();
  };

  const handleImport = () => {
    onImport(updateMode);
    onClose();
  };

  return (
    <div className={classes.overlay} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <header className={classes.header}>
          <h3>Import Options</h3>
          <button className={classes.closeBtn} onClick={onClose}>
            ×
          </button>
        </header>

        <div className={classes.body}>
          <div className={classes.checkboxContainer}>
            <label className={classes.checkboxLabel}>
              <input
                type="checkbox"
                checked={updateMode}
                onChange={(e) => setUpdateMode(e.target.checked)}
                className={classes.checkbox}
              />
              <span className={classes.checkboxText}>
                If you want to update the product then check
              </span>
            </label>
          </div>

          <div className={classes.infoText}>
            {updateMode ? (
              <p>
                Products will be updated based on SKU. If a product with the same
                SKU exists, it will be updated with data from the Excel file.
              </p>
            ) : (
              <p>
                New products will be added from the Excel file. Existing
                products will be skipped.
              </p>
            )}
          </div>
        </div>

        <footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes.btnSecondary}`}
            onClick={handlePreview}
            disabled={loading}
          >
            Preview
          </button>
          <button
            className={`${classes.btn} ${classes.btnPrimary}`}
            onClick={handleImport}
            disabled={loading}
          >
            {loading ? "Importing..." : "Import"}
          </button>
        </footer>
      </div>
    </div>
  );
}
